import React, {useEffect} from 'react';
import {useLocation} from 'react-router-dom';


function ScrollToTop({}) {

    const {hash, pathname, search} = useLocation();

    useEffect(() => {

        // don't scroll if hash is set to keep anchoring possible
        if (hash) {

            return;
        }

        window.scrollTo(0, 0);

    }, [pathname, search]);

    return null;
}


export default ScrollToTop;
